import { BrowserCacheLocation } from '@azure/msal-browser';
import { Environment } from './model/Environment';
declare function require(moduleName: string): any;

export const environment: Environment = {
    production: false,
    target: 'PPD',
    useMock: false,
    version: require('../../package.json').version,
    webRoot: 'https://ppdadminweb.mygphc.org',
    maintenanceAPIURL:  'https://webapp-t1ppd-maintapi-4874.azurewebsites.net',
    msal: {
        auth: {
        clientId: 'f1f80a8e-c75d-4e71-81f8-694ba19fa745',
        authority: 'https://login.microsoftonline.com/42db843f-8f58-4b3c-8a85-a80d906ff0f2',
        redirectUri: 'https://ppdadminweb.mygphc.org',
        postLogoutRedirectUri: 'https://ppdadminweb.mygphc.org',
        scope: 'https://pharmacyregulation.onmicrosoft.com/t1ppdMyGPhCAdminApi/user_impersonation'
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage
        }    
      },
    api: {
        root: 'https://ppdadminapi.mygphc.org'
    }
};
